import { put, takeLatest, take } from 'redux-saga/effects';

import * as documentDeleteReq from '../documents-delete-req';

function* handleSuccessDelete({ payload }) {
  yield take(documentDeleteReq.consts.SUCCEED);
  yield put(documentDeleteReq.actions.deleteSuccess(payload.docId));
}

export function* deleteDocumentWatcher() {
  yield takeLatest(documentDeleteReq.consts.SEND, handleSuccessDelete);
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/delete-document-saga.js